import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../Common/Pagination/Pagination";
import CountUp from "react-countup";
import { useReactToPrint } from "react-to-print";

const GovtOrderStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [companyId, setCompanyId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [status, setStatus] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [statusOrder, setStatusOrder] = useState([]);
  const [govtCountData, setGovtCountData] = useState([]);
  const [printIndex, setPrintIndex] = useState(null);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + statusOrder?.length - 1, totalRecords);

  const componentPDFRefs = useRef([]);
  const bulkPDFRef = useRef(null);

    const [filterCriteria, setfilterCriteria] = useState({
      discom_name: "",
      rca_number:""
    });

    const handleFilterChange = (name, value) => {
      setfilterCriteria(() => {
        return {
          ...filterCriteria,
          [name]: value,
        };
      });
    };

  const handlePrint = useReactToPrint({
    content: () => componentPDFRefs.current[printIndex],
    pageStyle: `
      @page {
        size: auto !important;
      }
      @media print {
        .print_btn {
          display: none;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
        }
      }`,
    documentTitle: "Govt Order Status",
    onAfterPrint: () => setPrintIndex(null),
  });

  const handlePrintBulk = useReactToPrint({
    content: () => bulkPDFRef.current,
    pageStyle: `
      @page {
        size: auto !important;
      }
      @media print {
        .print_btn {
          display: none;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
        }
      }`,
    documentTitle: "Govt Order Status",
    onAfterPrint: () => setPrintIndex(null),
  });

  const generatePDF = (index) => {
    setPrintIndex(index);
  };

  useEffect(() => {
    if (printIndex !== null) {
      handlePrint();
    }
  }, [printIndex]);

  const getGovtOrderCount = async () => {
    const renewalDate = moment(selectedDate).format("YYYY-MM-DD");
    let BASE_URL =
      SERVER_URL +
      `/api/order-status/govt-order-status-count/${user_id}?date=${renewalDate}&companyId=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setGovtCountData(result.data);
    } else {
      setGovtCountData([]);
    }
  };

  useEffect(() => {
    getGovtOrderCount();
  }, [companyId, selectedDate]);

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };

  const getOrderStatusData = async () => {
    const currentQueryDate = moment(selectedDate).format("YYYY-MM-DD");
    const BASE_URL = `${SERVER_URL}/api/order-status/govt-order-status-report/${user_id}?date=${currentQueryDate}&status=${status}&companyId=${companyId}&take=${pageSize}&skip=${
      (currentPage - 1) * pageSize
    }&rca_number=${filterCriteria.rca_number}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setStatusOrder(result.data);
    } else {
      setStatusOrder([]);
    }
  };

  useEffect(() => {
    getOrderStatusData();
  }, [currentPage, pageSize, selectedDate, status, companyId, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [status]);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleChange = (value) => {
    setStatus(value);
  };

  const calculateTotalCostWithGST = (orderDetails) => {
    return orderDetails.reduce(
      (total, order) => total + order.cost_with_gst,
      0
    );
  };

  const companyTables = statusOrder?.map((company, index) => (
    <div
      key={index}
      className="table-responsive table-bordered govt-table mt-4"
      style={{
        border: "0.05px solid lightGray",
        width: "100%",
      }}
    >
      <table
        className="table"
        ref={(el) => (componentPDFRefs.current[index] = el)}
      >
        <thead>
          <tr className="table-heads">
            <td>
              <span style={{ fontWeight: "bold" }}>Company: </span>
              {company?.company_name}
            </td>
            <td>
              <span style={{ fontWeight: "bold" }}>Region: </span>
              {company.discom_name}
            </td>
            <td
              style={{
                textTransform: "capitalize",
              }}
            >
              <span style={{ fontWeight: "bold" }}>Status: </span>
              {company.status}
            </td>
            <td colSpan={2}>
              <span style={{ fontWeight: "bold" }}>RCA Number: </span>
              {company.rca_number}
            </td>
            <td>
              <span style={{ fontWeight: "bold" }}>Total Alloted: </span>
              {company.total_alloted}
            </td>
            <td>
              <span style={{ fontWeight: "bold" }}>RCA Balance: </span>
              {company.rca_balance}
            </td>
            <td>
              <span style={{ fontWeight: "bold" }}>RCA Date: </span>
              {company.rca_date}
            </td>
            <td colSpan={1}>
              <span style={{ fontWeight: "bold" }}>BG Status: </span>
              {company?.bg_status}
            </td>
            <td colSpan={1}>
              <span style={{ fontWeight: "bold" }}>BG Number: </span>
              {company?.bg_number}
            </td>
            <td colSpan={1}>
              <span style={{ fontWeight: "bold" }}>Validity: </span>
              {company?.validity}
            </td>
            <td>
              <span className="print_btn">
                <i
                  className="mdi mdi-printer-eye"
                  style={{ fontSize: "25px" }}
                  onClick={() => generatePDF(index)}
                ></i>
              </span>
            </td>
          </tr>
          <tr>
            <th>S.NO</th>
            <th>Circle</th>
            <th>Product Name</th>
            <th>Order Number</th>
            <th>Order Qty</th>
            <th>Order Balance</th>
            <th>Date</th>
            <th>Last Date Of Offer</th>
            <th>Status</th>
            <th>Rate</th>
            <th>Order Value</th>
            <th>Order Value With GST</th>
          </tr>
        </thead>

        <tbody>
          {company &&
            company?.orderDetails?.length > 0 &&
            company?.orderDetails?.map((order, orderIndex) => (
              <tr key={orderIndex}>
                <td>{orderIndex + 1}</td>
                <td>{order.circle}</td>
                <td>{order.product_name}</td>
                <td>{order.order_number}</td>
                <td>{order.total_order_qty}</td>
                <td>{order.rca_balance}</td>
                <td>{order.date}</td>
                <td>{order.last_date_offer}</td>
                <td>{order.status}</td>
                <td>{order.rate}</td>
                <td>{order.cost}</td>
                <td>{order.cost_with_gst}</td>
              </tr>
            ))}
          <tr>
            <td
              style={{
                borderTop: "3px solid #d3d3d3",
                alignItems: "center",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              colSpan="11"
            >
              Total Cost with GST:
            </td>
            <td
              style={{
                borderTop: "3px solid #d3d3d3",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {calculateTotalCostWithGST(company.orderDetails)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ));

  return (
    <>
      {" "}
      <div className="card mt-4">
        <div className="card-body">
          <div>
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <p className="card-title">Government Order Status</p>
              <div style={{ display: "flex" }}>
                <select
                  className="form-control ml-2"
                  onChange={handleCompanyChange}
                  value={companyId} // Set the value of the dropdown to the companyId state
                >
                  <option value="">Select Company (All)</option>
                  {companyDetails &&
                    companyDetails?.length > 0 &&
                    companyDetails?.map((item, id) => {
                      return (
                        <option
                          key={id}
                          value={item.id}
                        >{`${item.companyName}, ${item.location}`}</option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi mdi-bank menu-icon mr-4 icon-lg dashboard-icon`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Total RCA</small>
                    <h2>
                      <CountUp end={totalRecords} duration={2} separator="," />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi 
                    mdi-invoice-text-check
                  menu-icon mr-4 icon-lg text-success`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Active</small>
                    <h2>
                      <CountUp
                        end={govtCountData?.activeCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi 
                    mdi-invoice-text-remove
                  menu-icon mr-4 icon-lg text-secondary`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Inactive</small>
                    <h2>
                      <CountUp
                        end={govtCountData?.inactiveCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <div className="card-body">
          <div className="search mb-3 mt-3">
            <div className="row justify-content-end">
              <div className="col-md-2">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={(e) =>
                      handleChange(e.target.value === "" ? "" : e.target.value)
                    }
                    value={status} // Set the value of the dropdown to the status state
                  >
                    <option value="all">Select Status (All)</option>
                    <option value="false">Active</option>
                    <option value="true">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="status_heading">
            <div className="status_heading">
              <h5>
                Govt Order Status As On Date:{" "}
                {moment(selectedDate).format("DD-MM-YYYY")}
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="col-md-6">
                <div className="form-group flex-grow-1 me-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by RCA number"
                    id="discomName"
                    name="rca_number"
                    onChange={(e) =>
                      handleFilterChange("rca_number", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="justify-content-end d-flex">
                <button
                  className="btn btn-sm btn-primary print_btn"
                  type="button"
                  disabled={
                    statusOrder && statusOrder?.length > 0 ? false : true
                  }
                  onClick={() => handlePrintBulk()}
                >
                  Print All
                  <i
                    className="mdi mdi-printer-eye"
                    style={{ fontSize: "20px" }}
                  ></i>
                </button>
              </div>
            </div>
          </div>
          {/* <div className="justify-content-end d-flex">
            <button
              className="btn btn-sm btn-primary print_btn"
              type="button"
              disabled={statusOrder && statusOrder?.length > 0 ? false : true}
              onClick={() => handlePrintBulk()}
            >
              Print All
              <i
                className="mdi mdi-printer-eye"
                style={{ fontSize: "20px" }}
              ></i>
            </button>
          </div> */}

          <div className="private-table-container" ref={bulkPDFRef}>
            {companyTables}
          </div>
          <div style={{ marginTop: "20px" }}>
            <Pagination
              currentPage={currentPage}
              totalRecords={totalRecords}
              pageSize={pageSize}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GovtOrderStatus;
